module.exports = __webpack_public_path__ + "static/media/liveroom-vip-bg.0974fdee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/liveroom-vip-bg.png
// module id = 1950
// module chunks = 6